import Vue from 'vue'
import Vuex from 'vuex'
import auth from './module/auth'
import active from './module/active'
import img from './module/img'
Vue.use(Vuex)

export default new Vuex.Store({
  state: {},
  getters: {},
  mutations: {},
  actions: {},
  modules: {
    auth,
    active,
    img
  }
})
